const theme = {
  primary: '#f7b51b',
  secondary: '#555454',
  background: '#fef8e2',
  onBackground: '#000000',
  onPrimary: '#000000',
  onSecondary: '#ffffff',
  onSurface: '#000000',
  surface: '#ffffff',
  bodyBackground: '#f9fbfd',
}
export default theme
